import { BadgeLadderTier } from "@shared/models";

/**
 * The Lifetime Flame subtitle text — `"{lifetimeTotal} all time · {pointsToNext} to the next level"`,
 * falling back to `"{lifetimeTotal} all time · Max tier reached"` once there's no next tier to reach
 * (lifetime-flame-rebuild plan). The distance comes from `nextTier`/`pointsToNext` — never
 * `currentTier`, which names the rung already reached, not the one being filled toward.
 *
 * The next tier's own NAME is never shown (pavel's mystery-badges decision: the names of flame/tenure
 * levels not yet reached are hidden too, the same as any other unearned badge) — `nextTier` is read
 * only to decide whether one exists at all, never for its `.name`.
 *
 * @param lifetimeTotal - the person's all-time flame total (`FlameProgress.lifetime_total`).
 * @param pointsToNext - points remaining to `nextTier`, or `null` once there's no tier left to reach.
 * @param nextTier - the tier being filled toward, or `null` when already at the top tier.
 * @returns the subtitle text.
 */
export const flameSubtitle = (
  lifetimeTotal: number,
  pointsToNext: number | null,
  nextTier: BadgeLadderTier | null,
): string =>
  nextTier === null || pointsToNext === null
    ? `${lifetimeTotal} all time · Max tier reached`
    : `${lifetimeTotal} all time · ${pointsToNext} to the next level`;
